export default function getLanguageFromPath(path){
  let p = path;
  if(p){
    p = p.toLowerCase();
    if(p.startsWith('/website')){
      p = p.substring('/website'.length);
    }

    if(p.startsWith('/cs')){
      return 'cs';
    } 
    else if(p.startsWith('/cz')){
      return 'cs';
    }
    else if(p.startsWith('/en')){
      return 'en';
    }
    else if(p.startsWith('/ru')){
      return 'ru';
    }
    else if(p.startsWith('/uk')){
      return 'uk';
    }
    else if(p.startsWith('/fr')){
      return 'fr';
    }
    else if(p.startsWith('/es')){
      return 'es';
    }

  }

  return 'en';
}



// WEBPACK FOOTER //
// ./src/application/utils/getLanguageFromPath.js